import { render, staticRenderFns } from "./ListPlates.vue?vue&type=template&id=799e798e&"
import script from "./ListPlates.vue?vue&type=script&lang=js&"
export * from "./ListPlates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports